export default "__VITE_ASSET__BhRrsVgC__"